import {BasePqForm} from "biz-ts/src/api/Paging";
import {MqttClientType} from "@/module/mqtt/MqttClientType";
import {MqttEventType} from "@/module/mqtt/MqttEvent";

class DmqttEventPqFormOptions {
    createdAtStart: Date | undefined = undefined
    createdAtEnd: Date | undefined = undefined
    clientTypes: Array<MqttClientType> = []
    eventTypes: Array<MqttEventType> = []
    payload: string | undefined = undefined
}

export class DmqttEventPqForm extends BasePqForm {
    deviceId!: number
    clientTypes: Array<MqttClientType> = []
    eventTypes: Array<MqttEventType> = []
    payload: string | undefined = undefined

    constructor(deviceId: number, options: DmqttEventPqFormOptions | undefined = undefined) {
        super();
        const opts = options ?? new DmqttEventPqFormOptions()
        this.deviceId = deviceId
        super.createdAtStart = opts.createdAtStart
        super.createdAtEnd = opts.createdAtEnd
        this.clientTypes = opts.clientTypes
        this.eventTypes = opts.eventTypes
        this.payload = opts.payload
    }
}

export class DmqttPublishAllForm {
    force = false
}
